import { protectFeature } from '~libs.shared.system';

export const isPrescriptionVisitSettlementAvailable = (): boolean =>
   protectFeature('settlingMedicalServicesPerformedByOneself') ||
   protectFeature('settlingMedicalServicesPerformedByAnyPractitioner') ||
   protectFeature('privateMedicalServicesReadOnly');
